
import HcmHeaderEn from '../i18n/en/components/HcmHeader.json'
import HcmHeaderEs from '../i18n/es/components/HcmHeader.json'
import HcmHeaderPtBr from '../i18n/pt-BR/components/HcmHeader.json'
import HcmFooterEn from '../i18n/en/components/HcmFooter.json'
import HcmFooterEs from '../i18n/es/components/HcmFooter.json'
import HcmFooterPtBr from '../i18n/pt-BR/components/HcmFooter.json'
import {
  pages,
  urlPrefixEN,
  urlPrefixES,
  urlPrefixPT,
  urlToken,
} from '~/config/i18n.pages'
import Provider from '@/services/provider'
import { v4 as uuidv4 } from 'uuid'
import getCookieDomain from '~/utils/getCookieDomains'

const locales = {
  ES: 'es',
  EN: 'en',
  PT_BR: 'pt-br',
}
export default {
  data() {
    return {
      pageItem: {
        locale: {
          'pt-br': '',
          en: '',
          es: '',
        },
      },
      basePath: {
        'pt-br': `${urlPrefixPT}`,
        en: `${urlPrefixEN}`,
        es: `${urlPrefixES}`,
      },
      urlToken,
    }
  },

  computed: {
    availableLocales() {
      return this.getAvailableLocales()
    },
    headerConfig() {
      return this.getHeaderConfig()
    },
    footerConfig() {
      return this.getFooterConfig()
    },

    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
  },

  methods: {
    getHeaderConfig() {
      const locale = this.$i18n.locale
      if (locale === locales.ES) {
        return HcmHeaderEs
      } else if (locale === locales.EN) {
        return HcmHeaderEn
      }

      return HcmHeaderPtBr
    },
    getFooterConfig() {
      const locale = this.$i18n.locale
      if (locale === locales.ES) {
        return HcmFooterEs
      } else if (locale === locales.EN) {
        return HcmFooterEn
      }

      return HcmFooterPtBr
    },
    getUrl(newLocale) {
      const locale = this.$i18n.locale
      const basePath = this.basePath
      const pageItem = this.pageItem
      const urlToken = this.urlToken
      const $route = this.$route

      let newUrl = ''
      if ($route.params.id) {
        newUrl = `/${newLocale}/${basePath[`${newLocale}`]}/${
          urlToken.positions[`${newLocale}`]
        }/${$route.params.id}`
      } else {
        const keys = Object.keys(pages)
        const key = keys.find(
          (key) => `/${locale}${pages[key][locale]}` === $route.path
        )

        if (!key || !pages[key][newLocale]) {
          return
        }

        newUrl = `/${newLocale}${pages[key][newLocale]}`
      }

      return newUrl
    },
    changeRoute(newLocale) {
      const positionUrls = [
        {
          origin: 'positions/',
          to: '/en/jobs',
        },
        {
          origin: 'vagas/',
          to: '/pt-br/trabalhe-conosco',
        },
        {
          origin: 'ofertas/',
          to: '/es/trabaja-con-nosotros',
        },
      ]
      const newUrl = this.getUrl(newLocale)

      const positionUrl = positionUrls.find((positionUrl) =>
        newUrl.includes(positionUrl.origin)
      )

      if (positionUrl) {
        return this.$router.replace(positionUrl.to, () => {
          this.$router.go(0)
        })
      }

      this.availableLocales = this.getAvailableLocales(newLocale)
      this.$router.replace(newUrl, () => {
        this.$router.go(0)
      })
    },
    getAvailableLocales(newLocale = '') {
      const locale = newLocale || this.$i18n.locale
      const { BASE_URL } = process.env
      const footerConfig = this.footerConfig || this.getFooterConfig()

      return footerConfig.availableLocales.map((availableLocale) => ({
        ...availableLocale,
        current: locale === availableLocale.code,
        href: `${BASE_URL}${this.getUrl(availableLocale.code)}`,
      }))
    },
  },
  mounted() {
    let userId = this.$cookies.get('sentry_uuid')
    if (!userId) {
      userId = uuidv4()
      const cookieDomain = getCookieDomain(process.env.BASE_URL)
      this.$cookies.set('sentry_uuid', userId, {
        domain: cookieDomain,
        path: '/',
        secure: window.location.protocol === 'https:',
        sameSite: 'lax',
      })
    }

    this.$sentry.setUser({
      id: userId,
      ip_address: '{{auto}}',
    })

    this.$sentry.setTag('locale', this.$i18n.locale)
    this.$sentry.setTag('route', this.$route.name)
    this.$sentry.setTag('environment', process.env.ENVIRONMENT || 'development')
    this.$sentry.startSession()
  },
}
